import { observer } from 'mobx-react';
import React, { useCallback, useEffect } from 'react';
import ModifiersListRow from '../../components/ModifiersListRow/ModifiersListRow';
import modifiersStore from '../../store/modifiersStore';
import { MODIFIERS_COLUMN_NAME } from '../../types/modifiers';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { SORTING_DIRECTION } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { formatImagePath } from 'src/utils/formatter';
import { emptyArray } from 'src/utils/helpers';
import ColumnTitle from 'src/view/components/ColumnTitle/ColumnTitle';
import Pagination from 'src/view/components/Controls/PaginationOld/PaginationOld';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';

const ModifiersList: React.FC = observer((): JSX.Element => {
  useEffect(() => {
    modifiersStore.fetchModifiers(1);
    modifiersStore.fetchModifiersCount();
  }, []);

  const setFilters = useCallback((sortField: MODIFIERS_COLUMN_NAME | undefined, sortDir: SORTING_DIRECTION | undefined) => {
    modifiersStore.setFilters({ sort_field: sortField, sort_dir: sortDir });
  }, []);

  const availabilityColumnTitle: string = modifiersStore.pagination.total && modifiersStore.pagination.data[0].is_delete ? ' ' : 'availability';
  const noFoundText: string = localeStore.t(
    modifiersStore.filters.search || modifiersStore.filters.availability || modifiersStore.foundModifiersInSystem
      ? 'no_modifiers_found'
      : 'no_modifiers_yet'
  );

  return (
    <div className="d-flex flex-column flex-grow-1 pt-4">
      {!modifiersStore.pagination.total && !modifiersStore.isLoading ? (
        <div className="d-flex flex-column justify-content-center align-items-center mt-6">
          <img src={formatImagePath(`${Icons.Modifiers}.svg`)} alt={noFoundText} className="image__no-found mb-6" />
          <p className="family-medium text-size-24 color-gray2">{noFoundText}</p>
        </div>
      ) : (
        <>
          <div className="d-flex flex-row mb-4 pr-5">
            <ColumnTitle<MODIFIERS_COLUMN_NAME>
              title="modifier"
              columnName={MODIFIERS_COLUMN_NAME.NAME}
              currentField={modifiersStore.filters.sort_field}
              currentDir={modifiersStore.filters.sort_dir}
              setFilters={setFilters}
              className="w-70"
            />
            <ColumnTitle<MODIFIERS_COLUMN_NAME> title={availabilityColumnTitle} className="w-30" />
          </div>
          <ScrollableBlock showScrollbar scrollClassName="d-flex flex-column full-height pr-4" className="mb-3">
            {modifiersStore.isLoading && !modifiersStore.pagination.total
              ? emptyArray().map((_, index) => <ModifiersListRow key={'key-' + String(index)} />)
              : modifiersStore.pagination.data.map((modifier) => <ModifiersListRow key={modifier.id} modifier={modifier} />)}
          </ScrollableBlock>
        </>
      )}
      <Pagination pagination={modifiersStore.pagination} onChange={modifiersStore.fetchModifiers} />
    </div>
  );
});

export default ModifiersList;
